import { QuickbookIntegrationEN } from '@/core/components/help-and-support/quick-answers/quickbook-integration/en'
import { QuickbookIntegrationES } from '@/core/components/help-and-support/quick-answers/quickbook-integration/es'
import { useIntlSelector } from '@/core/hooks/useIntlSelector'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/help-and-support/quick-answers/quickbook-integration/'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { locale } = useIntlSelector()

  switch (locale) {
    case 'en':
      return <QuickbookIntegrationEN />
    case 'es':
      return <QuickbookIntegrationES />
  }
}
